// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on (A12U10).
import { ids } from '@orca/api-client/testIds'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '../../components/ui/page-header'
import { EmailChange } from '../../features/account/EmailChange'
import { meQuery } from '../../shared/org/me'
import { text } from '../../shared/routing/search'
import { Part } from '../../shared/shell/StatePart'

export const Route = createFileRoute('/account/email')({
  staticData: { screenId: 'AccountEmailScreen', access: 'signed in, not demo' },
  // The route key's query arguments (screens.json `args`), as the apps' LinkResolver reads them;
  // unknown keys are dropped.
  validateSearch: (search: Record<string, unknown>): { token?: string } => ({
    token: text(search.token),
  }),
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(meQuery()),
  component: AccountEmailScreen,
})

function AccountEmailScreen() {
  const { t } = useTranslation()
  const { token } = Route.useSearch()
  return (
    <main data-testid={ids.accountEmail.root} className="flex flex-col gap-(--stack-lg)">
      <PageHeader title={t('account.email.title')}>
        <Lede />
      </PageHeader>
      <Part testId={ids.accountEmail.skeleton}>
        <EmailChange token={token} />
      </Part>
    </main>
  )
}

function Lede() {
  const { t } = useTranslation()
  const { data: me } = useSuspenseQuery(meQuery())
  return <p className="text-fg-muted">{t('account.email.lede', { email: me?.user.email ?? '' })}</p>
}
